import type {
  TSeasonBlockKind,
  TSeasonIntakeMode,
  TSeasonSelector,
} from '@/modules/season/season.types'

// React Query keys.
export const SEASON_QUERY_KEYS = {
  list: ['seasons', 'list'] as const,
  detail: (id: string) => ['seasons', 'detail', id] as const,
  teams: (id: string, page: number, per_page: number, q: string) =>
    ['seasons', 'teams', id, page, per_page, q] as const,
  teamMemberships: (teamId: string) =>
    ['seasons', 'team-memberships', teamId] as const,
  applications: (id: string) => ['seasons', 'applications', id] as const,
  applicationRuleCatalog: ['seasons', 'application-rule-catalog'] as const,
  context: ['seasons', 'context'] as const,
  eligibleCount: (tagIds: string[], min: number | null, max: number | null) =>
    ['seasons', 'eligible-count', tagIds, min, max] as const,
}

// MIME type used by native HTML5 drag-and-drop to carry the block kind from
// the palette into a period drop zone.
export const SEASON_DND_MIME = 'application/x-bilgilig-block'

export const BLOCK_LABELS: Record<TSeasonBlockKind, string> = {
  application: 'Başvuru',
  league: 'Lig',
  matchup: 'Eşleşme',
  tournament: 'Turnuva',
  transfer: 'Transfer Sezonu',
}

export const BLOCK_DESCRIPTIONS: Record<TSeasonBlockKind, string> = {
  application:
    'Takımlar bu bloğa başvurur; şartları sağlayan başvuruları admin değerlendirir.',
  league: 'Lig bloğu. Gruplar, puanlama ve koşullar blok içinde ayarlanır.',
  tournament: 'Turnuva bloğu. Braket boyutu, oyun modu ve koşullar.',
  matchup:
    'Eşleştirme turu. Takımlar eşleşir, kazananlar bir sonraki bloğa taşınır.',
  transfer:
    'Takımların kadro değiştirebileceği aralık. Sezona dahil takımlar yalnızca bu periyot süresince oyuncu transferi yapabilir; periyodun başlangıç/bitiş tarihleri transfer penceresini belirler.',
}

// Blocks that produce a ranking and therefore support win/lose conditions.
export const RANKED_BLOCK_KINDS: TSeasonBlockKind[] = [
  'league',
  'tournament',
  'matchup',
]

export const SELECTOR_LABELS: Record<TSeasonSelector, string> = {
  top: 'En üstteki',
  bottom: 'En alttaki',
  rank_range: 'Sıra aralığı',
  remaining: 'Geriye kalan',
}

export const INTAKE_MODE_LABELS: Record<TSeasonIntakeMode, string> = {
  tag: 'Etiketle (otomatik)',
  manual: 'Elle seçim',
  application: 'Başvuru',
}

export const INTAKE_MODE_DESCRIPTIONS: Record<TSeasonIntakeMode, string> = {
  tag: 'Seçilen etiketlere sahip uygun takımlar otomatik olarak sezona alınır.',
  manual: 'Yarışacak takımları listeden tek tek siz seçersiniz.',
  application:
    'Takımlar sezona başvurur; başvuranları inceleyip kabul/ret edersiniz.',
}

export const BLOCK_KINDS: TSeasonBlockKind[] = [
  'application',
  'league',
  'matchup',
  'tournament',
  'transfer',
]
